<template>
  <sliderBarDialogShell
    :dialog-show="dialogShow"
    :dialog-title="title"
    @close="beforeClose"
    @submit="confirm"
    class="add-wx-account-dialog"
  >
    <div class="form-content">
      <account-form
        ref="outform"
        @submit="submit"
      ></account-form>
    </div>
  </sliderBarDialogShell>
</template>

<script>
import accountForm from "@/components/wx/wx-account/accountForm";
import {saveAccount} from "@/api/wx/account";

export default {
  name: "addDialog",
  components: {
    accountForm,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: '新增'
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
      this.$refs.outform.selfClear();
    },
    cancel() {
      this.beforeClose();
    },
    confirm() {
      // todo
      this.$refs.outform.selfValidate();
    },
    submit(form) {

      let params = {
        ...form,
      }
      saveAccount(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '操作成功',
            type: 'success',
          });
          this.$emit('add-success');
        }else{
          this.$message.error(data.msg);
        }
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    }
  },
}
</script>

<style>
@media screen and (min-width: 768px) {
  .add-wx-account-dialog.sidebar-dialog .vs-sidebar {
    width: 800px;
  }
}
</style>
